import { render, staticRenderFns } from "./AddTermOfUse.vue?vue&type=template&id=98d9e284&"
import script from "./AddTermOfUse.vue?vue&type=script&lang=js&"
export * from "./AddTermOfUse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports